import Vue from 'vue'
import Router from 'vue-router'

import 'dayjs/locale/ja'
import dayjs from 'dayjs'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'
import calendar from 'dayjs/plugin/calendar'

import Header from '@/components/includes/Header'
import TinyHeader from '@/components/includes/TinyHeader'

import Menu from '@/components/includes/Menu'

import Dashboard from '@/components/Dashboard.vue'

import Summary from '@/components/Summary.vue'

import Peoples from '@/components/Peoples.vue'
import People from '@/components/People.vue'
import Status from '@/components/Status.vue'

import Setup from '@/components/Setup.vue'

import Jobs from '@/components/Jobs.vue'
import Job from '@/components/Job.vue'

import Routes from '@/components/Routes.vue'
import Route from '@/components/Route.vue'

import Users from '@/components/Users.vue'
import User from '@/components/User.vue'

import Boilerplates from '@/components/Boilerplates.vue'
import Boilerplate from '@/components/Boilerplate.vue'

import OtherMenu from '@/components/includes/OtherMenu.vue'
import Profile from '@/components/Profile.vue'
import Preference from '@/components/Preference.vue'
import Billings from '@/components/Billings.vue'
import Payment from '@/components/Payment.vue'
import Company from '@/components/Company.vue'
import Usage from '@/components/Usage.vue'

import ResetPassword from '@/components/ResetPassword.vue'

import Redirect from '@/components/Redirect'

import NotFound from '@/components/NotFound'

import { authGuard } from '../plugins/auth'

Vue.component('Header', Header)
Vue.component('TinyHeader', TinyHeader)

Vue.component('Menu', Menu)

Vue.component('Peoples', Peoples)
Vue.component('People', People)
Vue.component('Status', Status)

Vue.component('Jobs', Jobs)
Vue.component('Job', Job)

Vue.component('Routes', Routes)
Vue.component('Route', Route)

Vue.component('Users', Users)
Vue.component('User', User)

Vue.component('OtherMenu', OtherMenu)
Vue.component('Profile', Profile)
Vue.component('Preference', Preference)
Vue.component('Billings', Billings)
Vue.component('Payment', Payment)
Vue.component('Company', Company)
Vue.component('Usage', Usage)

Vue.component('Boilerplates', Boilerplates)
Vue.component('Boilerplate', Boilerplate)

dayjs.locale('ja')
dayjs.extend(LocalizedFormat)
dayjs.extend(relativeTime)
dayjs.extend(calendar)

Vue.filter('ago', (value) => {
  let str = ''
  const diff = dayjs().diff(value, 'day')
  if (diff === 0) {
    if (dayjs().format('MD') === dayjs(value).format('MD')) {
      str += '今日'
    } else {
      str += '昨日'
    }
  } else if (diff === 1) {
    if (dayjs().format('MD') === dayjs(value).format('MD')) {
      str += '昨日'
    } else {
      str += '一昨日'
    }
  } else if (diff === 2) {
    if (dayjs().format('MD') === dayjs(value).format('MD')) {
      str += '一昨日'
    } else {
      str += '3日前'
    }
  } else if (diff > 0) {
    str += diff + '日前'
  } else {
    str += Math.abs(diff) + '日後'
  }
  str += ' '
  str += dayjs(value).format('LT')
  return str
})

Vue.use(Router)

export default new Router({
  mode: 'history',
  // base: process.env.BASE_URL,
  base: '/',
  routes: [
    { path: '/index.html', redirect: '/' },
    { path: '/', name: 'Redirect', component: Redirect, beforeEnter: authGuard },

    { path: '/resetPassword', name: 'Reset Password', component: ResetPassword },

    { path: '/:directory/', name: 'Dashboard', component: Dashboard, beforeEnter: authGuard },

    { path: '/:directory/summary', name: 'Summary', component: Summary, beforeEnter: authGuard },

    { path: '/:directory/setup', name: 'Setup', component: Setup, beforeEnter: authGuard },
    // { path: '/setup', name: 'SetupMenu', component: Setup, beforeEnter: authGuard },

    { path: '/:directory/setup/profile', name: 'MyProfile', component: Setup, beforeEnter: authGuard },
    { path: '/:directory/setup/preference', name: 'Preference', component: Setup, beforeEnter: authGuard },
    { path: '/:directory/setup/billings', name: 'Billings', component: Setup, beforeEnter: authGuard },
    { path: '/:directory/setup/payment', name: 'ChangePayment', component: Setup, beforeEnter: authGuard },
    { path: '/:directory/setup/company', name: 'MyCompany', component: Setup, beforeEnter: authGuard },
    { path: '/:directory/setup/usage', name: 'Usage', component: Setup, beforeEnter: authGuard },

    { path: '/:directory/peoples', name: 'List Peoples', component: Peoples, props: { mode: 'list' }, beforeEnter: authGuard },
    { path: '/:directory/people/:id', name: 'Disp People', component: Status, props: { mode: 'status' }, beforeEnter: authGuard },
    { path: '/:directory/people/', name: 'Add People', component: People, props: { mode: 'add' }, beforeEnter: authGuard },
    { path: '/:directory/people/edit/:id', name: 'Edit People', component: People, props: { mode: 'edit' }, beforeEnter: authGuard },

    { path: '/:directory/jobs', name: 'List Jobs', component: Jobs, beforeEnter: authGuard },
    { path: '/:directory/job/:id', name: 'Edit Job', component: Job, props: { mode: 'show' }, beforeEnter: authGuard },
    { path: '/:directory/job', name: 'Add Job', component: Job, props: { mode: 'add' }, beforeEnter: authGuard },

    { path: '/:directory/routes', name: 'List Routes', component: Routes, beforeEnter: authGuard },
    { path: '/:directory/route/:id', name: 'Edit Route', component: Route, props: { mode: 'show' }, beforeEnter: authGuard },
    { path: '/:directory/route', name: 'Add Route', component: Route, props: { mode: 'add' }, beforeEnter: authGuard },

    { path: '/:directory/users', name: 'List Users', component: Users, beforeEnter: authGuard },
    { path: '/:directory/user/:id', name: 'Edit User', component: User, props: { mode: 'show' }, beforeEnter: authGuard },

    { path: '/:directory/boilerplates', name: 'List Boilerplates', component: Boilerplates, beforeEnter: authGuard },
    { path: '/:directory/boilerplate/:id', name: 'Edit Boilerplate', component: Boilerplate, props: { mode: 'show' }, beforeEnter: authGuard },
    { path: '/:directory/boilerplate', name: 'Add Boilerplate', component: Boilerplate, props: { mode: 'add' }, beforeEnter: authGuard },

    { path: '/:directory/*', component: NotFound }
  ]
})
